import Link from "next/link";
import { ChevronRight } from "lucide-react";

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="Breadcrumb" className="min-w-0 text-sm">
      <ol
        itemScope
        itemType="https://schema.org/BreadcrumbList"
        className="leading-5"
      >
        {items.map((item, index) => (
          <li
            key={index}
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
            className="inline"
          >
            {index > 0 && (
              <ChevronRight className="mx-2 inline-block h-3 w-3 text-muted-foreground" />
            )}
            {item.href ? (
              <Link
                href={item.href}
                itemProp="item"
                className="text-muted-foreground transition-colors hover:text-foreground"
              >
                <span itemProp="name">{item.label}</span>
              </Link>
            ) : (
              <span itemProp="name" className="font-medium text-foreground">
                {item.label}
              </span>
            )}
            <meta itemProp="position" content={String(index + 1)} />
          </li>
        ))}
      </ol>
    </nav>
  );
}
